import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function GoogleAuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get("token");
    const userId = query.get("user_id");
    const flag = query.get("flag");

    if (token && userId) {
      localStorage.setItem("jwt_token", token);
      localStorage.setItem("user_id", userId);
      localStorage.setItem("passwordChangeRequired", flag === "1" ? "true" : "false");

      if (flag === "1") {
        navigate("/change-password");
      } else {
        navigate("/dashboard");
      }
    } else {
      console.warn("Missing token or user_id in Google callback");
      navigate("/login");
    }
  }, [location, navigate]);

  return <div>Processing Google login...</div>;
}

export default GoogleAuthCallback;
